/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Assign_Track_CInputs */



/**
* | output |
* | --- |
* | "Assign the selected event(s) to track C" |
*
* @param {Shortcut_Keys_Desc_Assign_Track_CInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_assign_track_c = /** @type {((inputs?: Shortcut_Keys_Desc_Assign_Track_CInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Assign_Track_CInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuez le ou les événements sélectionnés au suivi C")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weisen Sie die ausgewählten Ereignisse der Spur C zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna l'evento/gli eventi selezionati al track C")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначьте выбранное событие (события) для отслеживания C.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asigne el/los evento(s) seleccionado(s) al seguimiento C.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的事件分配给跟踪 C。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをトラックCに割り当てます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटना(ओं) को ट्रैक C में असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribua o(s) evento(s) selecionado(s) à trilha C.")
	return /** @type {LocalizedString} */ ("Assign the selected event(s) to track C")
});